module.exports = __webpack_public_path__ + "static/media/edit.fdc29000.svg";